

const About = () => {


    return(
        <div className="about common-class">
            <h1>This is the practice website created by me using the swiggy api using react.</h1>
        </div>
    )
}

export default About;